<template>
  <div class="main lh-15 c-333">
    <!-- <section class="banner bgs-cover bgp-c w-100p t-0 p-fix">
      <div class="crumb d-f jc-fs ai-c ff-asl pl-60 in-pc">
        <nuxt-link class="c-fff" to="/">Home</nuxt-link><span class="c-fff"></span
        ><nuxt-link class="c-fff" to="/product">Product</nuxt-link><span class="c-fff"></span
        ><a class="c-fff ff-as">AL01 3D Land Leveling System</a>
      </div>
      <div class="banner-content c-fff p-a">
        <h1 class="banner-title m-0 ff-asb lh-13">
          <span class="ff-as d-b">AL01</span><i class="d-b">3D Land Leveling System</i>
        </h1>
        <div class="banner-desc">Leveled Farmland for Next-level Yield</div>
        <nuxt-link to="/dealer" target="_blank" class="banner-btn d-ib ta-c c-26">Contact Us</nuxt-link>
      </div>
    </section> -->
    <ProductBanner
      is-fixed
      is-scroll
      :banner-img="bannerImg"
      :product-name="'FJD AL01 3D Land Leveling System'"
      :product-img-style="{ backgroundImage: `url(${bannerProductImg})` }"
      :custom-style="{ bottom: '2.46rem', left: '2rem' }"
      :main-title="'FJD AL01'"
      :sub-title="'3D Land Leveling System'"
      :slogan="'Leveled Farmland For Next-level Yield'"
    >
    </ProductBanner>

    <!-- banner:end -->
    <div class="content p-r z-3 bgc-fff">
      <div class="nav-anchor w-100p bgc-fff l-0 z-98">
        <div class="h-100p m-a d-f jc-sb ai-c fs-16 c-26">
          <strong class="d-f ai-c fs-20"
            >FJD AL01 3D Land Leveling System<span class="d-n triangle-icon triangle-icon-fff bgs-cover bgp-c"></span
          ></strong>
          <div class="d-f">
            <div class="nav-anchor-item d-f jc-sb ai-c c-26">
              <a class="c-26" href="#overview">Overview</a>
              <a class="c-26" href="#feature">Features</a>
              <nuxt-link class="c-26" to="/product/al01-3d-land-leveling-system-specs">SPECs</nuxt-link>
            </div>
            <nuxt-link class="dealer-free-quote-btn d-ib ta-c bgc-222 c-fff in-pc" to="/basicinfo" target="_blank"
              >Free Quote</nuxt-link
            >
          </div>
        </div>
      </div>
      <!-- nav-anchor:end -->
      <section class="area-1 bgc-fafafa">
        <ul class="d-f jc-sb ta-c fw-w pl-360 pr-360">
          <li class="reveal">
            <i class="m-a d-b"
              ><img
                width="100%"
                height="100%"
                alt=" Precise Leveling Mode"
                src="data:image/svg+xml,%3Csvg width='140' height='140' viewBox='0 0 140 140' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Cdefs%3E%3Cpath id='a' d='M0 .644h4.295v2.147H0z'/%3E%3Cpath id='c' d='M0 .644h103.069v2.147H0z'/%3E%3Cpath id='e' d='M0 .644h4.295v2.147H0z'/%3E%3C/defs%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath stroke='%23050101' stroke-width='2' stroke-linecap='round' d='M11.364 98.199h125.103'/%3E%3Cpath stroke='%23050101' stroke-width='.581' stroke-linecap='round' d='M11.364 102.273h.708'/%3E%3Cpath stroke='%23050101' stroke-width='.581' stroke-linecap='round' stroke-dasharray='1.422634621461232,1.422634621461232' d='M13.493 102.273h121.556'/%3E%3Cpath stroke='%23050101' stroke-width='.581' stroke-linecap='round' d='M135.761 102.273h.708'/%3E%3Cg transform='translate(11.364 103.148)'%3E%3Cmask id='b' fill='%23fff'%3E%3Cuse xlink:href='%23a'/%3E%3C/mask%3E%3Cpath stroke='%23050101' stroke-width='.859' stroke-linecap='round' mask='url(%23b)' d='M0 2.362h4.295'/%3E%3C/g%3E%3Cg transform='translate(24.622 103.148)'%3E%3Cmask id='d' fill='%23fff'%3E%3Cuse xlink:href='%23c'/%3E%3C/mask%3E%3Cpath stroke='%23050101' stroke-width='.859' stroke-linecap='round' stroke-dasharray='8.961910168329874,8.961910168329874' mask='url(%23d)' d='M0 2.362h103.069'/%3E%3C/g%3E%3Cg transform='translate(132.173 103.148)'%3E%3Cmask id='f' fill='%23fff'%3E%3Cuse xlink:href='%23e'/%3E%3C/mask%3E%3Cpath stroke='%23050101' stroke-width='.859' stroke-linecap='round' mask='url(%23f)' d='M0 2.362h4.295'/%3E%3C/g%3E%3Cpath d='M38.532 85.847c.007 6.258-5.054 11.339-11.305 11.349-6.254.007-11.33-5.06-11.34-11.319-.007-6.258 5.055-11.338 11.309-11.349 6.25-.007 11.33 5.06 11.336 11.319z' stroke='%23050101' stroke-width='2'/%3E%3Cpath d='M67.61 98.2c-6.542-2.31-11.236-8.55-11.246-15.891-.014-9.32 7.522-16.88 16.83-16.894 9.306-.013 16.863 7.53 16.877 16.846.01 7.217-4.509 13.38-10.87 15.8' stroke='%23050101' stroke-width='2' stroke-linecap='round'/%3E%3Cpath stroke='%23050101' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' d='M33.868 55.83l12.652-.018 7.89-21.778L80.84 34l4.862 22.626.01 8.554M21.244 71.834l-5.395-15.98 10.268-.013M39.533 77.388l6.323-.007.01 6.427 6.378-.01M27.636 48.396l5.409-.006.017 11.85'/%3E%3Cpath stroke='%23050101' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' d='M59.618 39.95l-5.154 16.313 24.734-.031-4.137-16.302zM89 76.371l7.474 6.228h5.618'/%3E%3Cpath d='M100.214 70.056a27.22 27.22 0 0 1 2.88 12.221c0 5.661-1.722 10.92-4.667 15.28M102.655 77.379l15.708 12.809' stroke='%23050101' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M118.362 92.776a5.11 5.11 0 0 1-10.22 0 5.11 5.11 0 0 1 10.22 0zM129.058 92.776a5.11 5.11 0 0 1-10.22 0 5.11 5.11 0 0 1 10.22 0z' stroke='%23050101' stroke-width='2' stroke-linecap='round'/%3E%3C/g%3E%3C/svg%3E"
            /></i>
            <strong class="d-b c-26">Precise <br class="in-h5" />Leveling Mode</strong>
          </li>
          <li class="reveal">
            <i class="m-a d-b"
              ><img
                width="100%"
                height="100%"
                alt=" Wasteland Reclamation Mode"
                src="data:image/svg+xml,%3Csvg width='140' height='140' viewBox='0 0 140 140' xmlns='http://www.w3.org/2000/svg'%3E%3Cg stroke='%23050101' fill='none' fill-rule='evenodd'%3E%3Cpath stroke-width='1.971' stroke-linecap='round' stroke-linejoin='round' d='M139 94.319H92.606l-29.908-5.905-21.535 6.655-16.778-3.544-7.61-8.64L5.324 93.86 1 90.974'/%3E%3Cpath d='M46.295 81.92c-.38 6.15-5.682 10.827-11.839 10.448-6.156-.378-10.838-5.67-10.458-11.821.38-6.151 5.678-10.828 11.838-10.449 6.157.379 10.838 5.67 10.459 11.822z' stroke-width='1.971'/%3E%3Cpath d='M66.014 88.425a16.523 16.523 0 0 1-1.943-8.876c.566-9.157 8.455-16.12 17.622-15.555 9.164.565 16.134 8.44 15.568 17.597-.312 5.059-2.862 9.448-6.625 12.268' stroke-width='1.971' stroke-linecap='round'/%3E%3Cpath stroke-width='1.971' stroke-linecap='round' stroke-linejoin='round' d='M43.567 52.14l12.458.768L65.148 32l26.023 1.603 3.384 22.53-.468 7.531M30.143 67.082l-4.32-16.035 10.114.622M47.805 73.671l6.228.382-.39 6.317 6.282.385M37.892 44.451l5.326.328-.718 11.646'/%3E%3Cpath stroke-width='1.695' stroke-linecap='round' stroke-linejoin='round' d='M69.907 38.134l-6.089 15.71 24.355 1.498-3.058-16.271z'/%3E%3Cpath stroke-width='.986' stroke-linecap='round' d='M53.705 91.32l-3.282 7.012L61.787 108M50.422 98.333l-7.204 5.695M73.783 90.776l12.872 11.619M79.556 95.988l16.68 4.433M13.033 87.874l5.903 8.927'/%3E%3Cpath stroke-width='1.971' stroke-linecap='round' stroke-linejoin='round' d='M95.79 73.332l7.374 6.134h5.543'/%3E%3Cpath d='M106.168 66.663a26.748 26.748 0 0 1 2.841 12.032c0 5.572-1.698 10.75-4.604 15.04M108.577 73.873l15.496 12.61' stroke-width='1.971' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M124.073 89.03a5.036 5.036 0 0 1-5.041 5.028 5.036 5.036 0 0 1-5.041-5.028 5.036 5.036 0 0 1 5.04-5.028 5.036 5.036 0 0 1 5.042 5.028zM134.625 89.03a5.036 5.036 0 0 1-5.042 5.028 5.036 5.036 0 0 1-5.04-5.028 5.036 5.036 0 0 1 5.04-5.028 5.036 5.036 0 0 1 5.042 5.028z' stroke-width='1.971' stroke-linecap='round'/%3E%3C/g%3E%3C/svg%3E"
            /></i>
            <strong class="d-b c-26">Wasteland <br class="in-h5" />Reclamation Mode</strong>
          </li>
          <li class="reveal">
            <i class="m-a d-b"
              ><img
                width="100%"
                height="100%"
                alt="GNSS-based Leveling System "
                src="data:image/svg+xml,%3Csvg width='140' height='140' viewBox='0 0 140 140' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Cdefs%3E%3Cpath id='a' d='M0 .13h3.834v3.556H0z'/%3E%3Cpath id='c' d='M0 .682h3.834v2.452H0z'/%3E%3C/defs%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath d='M73.362 101.763a7.035 7.035 0 0 1 0-9.986l18.928-18.84c2.768-2.754 7.261-2.754 10.033 0a7.042 7.042 0 0 1 0 9.987l-18.928 18.839a7.116 7.116 0 0 1-10.033 0z' stroke='%23050101' stroke-width='2'/%3E%3Cpath d='M95.163 65.814c4.309-1.163 8.726-.34 11.693 2.614 2.967 2.954 3.796 7.35 2.626 11.635M66.203 94.638c-1.17 4.289-.341 8.685 2.626 11.638 2.968 2.953 7.384 3.778 11.69 2.614' stroke='%23050101' stroke-width='2' stroke-linecap='round'/%3E%3Cpath d='M72.011 83.16l-5.808-5.78a2.077 2.077 0 0 1 0-2.946l8.66-8.62a2.101 2.101 0 0 1 2.96 0l2.903 2.892 2.906 2.889a2.077 2.077 0 0 1 0 2.946l-8.66 8.62a2.101 2.101 0 0 1-2.96 0zM69.107 80.27l11.621-11.566M79.302 78.851l3.377 3.362M97.86 108.888l-5.808-5.781a2.077 2.077 0 0 1 0-2.946l8.66-8.62a2.101 2.101 0 0 1 2.96 0l2.903 2.892 2.906 2.889a2.077 2.077 0 0 1 0 2.946l-8.661 8.62a2.101 2.101 0 0 1-2.96 0zM94.956 105.997l11.621-11.566M93.499 92.982l3.377 3.361M36.919 48.273c.886 1.629 1.948 4.132 1.303 5.868-.533 1.439-.9 2.992-.674 4.53.222 1.53.667 3.106 1.568 4.388 1.108 1.572 2.607 1.98 4.363 2.51 1.652.5 3.335.913 5.026 1.29 1.537.344 3.128.954 4.348 1.977.582.489 1.1 1.088 1.353 1.813.127.362.192.744.18 1.125-.007.248-.314 1.046.15.893 1.986-.66 3.604-2.171 3.515-4.415-.103-2.606-.985-5.128-.989-7.75-.004-1.251.169-2.564.86-3.636 2.472-3.854 10.703-2.87 10.703-8.57 0-3.362 2.646-4.366 4.26-5.473 1.687-1.156 2.84-3.258 4.37-4.624 1.565-1.393 4.283-3.259 6.74-4.102' stroke='%23050101' stroke-width='2'/%3E%3Cg transform='translate(56.934 26)'%3E%3Cmask id='b' fill='%23fff'%3E%3Cuse xlink:href='%23a'/%3E%3C/mask%3E%3Cpath d='M1.336 1.917c.384-.099.77-.19 1.162-.278' stroke='%23050101' stroke-width='.87' stroke-linecap='round' mask='url(%23b)'/%3E%3C/g%3E%3Cpath d='M61.73 27.188a44.672 44.672 0 0 1 7.473-.626c21.78 0 39.88 15.68 43.534 36.315' stroke='%23050101' stroke-width='.87' stroke-linecap='round' stroke-dasharray='2.346355891227722,2.346355891227722'/%3E%3Cpath d='M112.924 64.027c.057.389.11.782.16 1.179' stroke='%23050101' stroke-width='.87' stroke-linecap='round'/%3E%3Cg transform='translate(58.98 111.184)'%3E%3Cmask id='d' fill='%23fff'%3E%3Cuse xlink:href='%23c'/%3E%3C/mask%3E%3Cpath d='M2.504 2.7a42.237 42.237 0 0 1-1.174-.22' stroke='%23050101' stroke-width='.87' stroke-linecap='round' mask='url(%23d)'/%3E%3C/g%3E%3Cpath d='M58.006 113.13C39.013 108.196 25 91.006 25 70.557c0-10.68 3.822-20.476 10.187-28.096' stroke='%23050101' stroke-width='.87' stroke-linecap='round' stroke-dasharray='2.365525317192078,2.365525317192078'/%3E%3Cpath d='M35.935 41.586c.26-.298.53-.592.798-.882' stroke='%23050101' stroke-width='.87' stroke-linecap='round'/%3E%3Cpath stroke='%23050101' stroke-width='.767' stroke-linecap='round' stroke-linejoin='round' d='M35.431 39.56h2.381l-.088 2.283M114.699 64.294l-1.526 1.82-1.706-1.53'/%3E%3Cpath d='M58.27 107.894c-16.494-4.686-28.567-19.797-28.567-37.716 0-21.659 17.644-39.22 39.405-39.22 17.498 0 32.332 11.353 37.473 27.059' stroke='%23050101' stroke-width='2' stroke-linecap='round'/%3E%3C/g%3E%3C/svg%3E"
            /></i>
            <strong class="d-b c-26">GNSS-based <br class="in-h5" />Leveling System </strong>
          </li>
          <li class="reveal">
            <i class="m-a d-b"
              ><img
                width="100%"
                height="100%"
                alt="Terrain Digitalization"
                src="data:image/svg+xml,%3Csvg width='140' height='140' viewBox='0 0 140 140' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Cdefs%3E%3Cpath d='M5.053 0C2.26 0 0 2.256 0 5.033v52.643c0 2.777 2.261 5.033 5.053 5.033H91.17c2.791 0 5.056-2.256 5.056-5.033V5.033C96.226 2.256 93.961 0 91.17 0H5.053z' id='a'/%3E%3Cpath d='M5.053 0C2.26 0 0 2.256 0 5.033v52.643c0 2.777 2.261 5.033 5.053 5.033H91.17c2.791 0 5.056-2.256 5.056-5.033V5.033C96.226 2.256 93.961 0 91.17 0H5.053z' id='c'/%3E%3Cpath d='M5.053 0C2.26 0 0 2.256 0 5.033v52.643c0 2.777 2.261 5.033 5.053 5.033H91.17c2.791 0 5.056-2.256 5.056-5.033V5.033C96.226 2.256 93.961 0 91.17 0H5.053z' id='e'/%3E%3Cpath d='M5.053 0C2.26 0 0 2.256 0 5.033v52.643c0 2.777 2.261 5.033 5.053 5.033H91.17c2.791 0 5.056-2.256 5.056-5.033V5.033C96.226 2.256 93.961 0 91.17 0H5.053z' id='g'/%3E%3Cpath d='M5.053 0C2.26 0 0 2.256 0 5.033v52.643c0 2.777 2.261 5.033 5.053 5.033H91.17c2.791 0 5.056-2.256 5.056-5.033V5.033C96.226 2.256 93.961 0 91.17 0H5.053z' id='i'/%3E%3Cpath d='M5.053 0C2.26 0 0 2.256 0 5.033v52.643c0 2.777 2.261 5.033 5.053 5.033H91.17c2.791 0 5.056-2.256 5.056-5.033V5.033C96.226 2.256 93.961 0 91.17 0H5.053z' id='k'/%3E%3C/defs%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg transform='translate(22 35)'%3E%3Cmask id='b' fill='%23fff'%3E%3Cuse xlink:href='%23a'/%3E%3C/mask%3E%3Cpath d='M29.801 21.688c2.642-1.48 5.792-2.074 8.525-2.019 5.466.106 14.862 4.031 8.514 11.433-3.384 3.944-5.367 5.766-5.338 11.874.014 2.814-3.084 3.062-5.228 2.847-7.329-.726-13.018-9.134-12.045-16.15.535-3.844 2.766-6.414 5.572-7.985z' stroke='%23050101' stroke-width='1.098' stroke-linecap='round' mask='url(%23b)'/%3E%3C/g%3E%3Cg transform='translate(22 35)'%3E%3Cmask id='d' fill='%23fff'%3E%3Cuse xlink:href='%23c'/%3E%3C/mask%3E%3Cpath d='M23.866 19.664c.674-.376 1.387-.667 2.115-.926.878-.313 1.775-.583 2.645-.911 3.344-1.258 5.777-3.459 9.052-4.217 3.61-.835 8.09-.375 11.912.656 3.659.984 6.923 2.923 9.454 5.12 1.68 1.462 3.926 3.215 3.461 6.073-.281 1.73-2.242 3.44-3.625 4.77-2.686 2.58-5.272 4.53-7.592 6.448-1.478 1.22-2.945 2.55-3.948 4.566-.644 1.29-.889 2.774-1.05 4.396-.113 1.155-.439 2.14-1.031 2.948-1.446 1.965-4.424 2.548-6.915 2.37-2.832-.209-5.496-1.327-7.943-2.763-4.54-2.668-8.485-6.495-10.918-10.996-1.189-2.198-2.074-4.589-2.053-7.074.037-4.662 2.756-8.401 6.436-10.46z' stroke='%23050101' stroke-width='1.025' stroke-linecap='round' mask='url(%23d)'/%3E%3C/g%3E%3Cg transform='translate(22 35)'%3E%3Cmask id='f' fill='%23fff'%3E%3Cuse xlink:href='%23e'/%3E%3C/mask%3E%3Cpath d='M17.931 17.64c.959-.537 1.987-.916 3.033-1.255 1.263-.408 2.55-.758 3.776-1.246 4.749-1.892 7.58-6.072 12.29-7.584 5.425-1.743 12.175-1.236 17.88-.019 5.465 1.17 10.342 3.91 14.685 6.761 2.773 1.819 7.208 4.002 6.864 8.208-.216 2.627-3.586 5.15-5.536 6.851-3.699 3.226-7.533 5.704-11.283 7.847-2.33 1.334-4.906 2.741-6.637 5.22-1.2 1.712-1.595 3.735-1.924 5.878-.23 1.49-.622 2.861-1.394 4.046-1.855 2.86-5.81 3.947-9.271 3.743-3.714-.226-7.215-1.724-10.486-3.492-6.07-3.28-11.671-7.592-15.578-13.059-1.907-2.671-3.49-5.681-3.721-8.962-.384-5.477 2.744-10.39 7.302-12.938z' stroke='%23050101' stroke-width='.952' stroke-linecap='round' mask='url(%23f)'/%3E%3C/g%3E%3Cg transform='translate(22 35)'%3E%3Cmask id='h' fill='%23fff'%3E%3Cuse xlink:href='%23g'/%3E%3C/mask%3E%3Cpath d='M11.996 15.615c1.244-.697 2.587-1.167 3.952-1.582 1.642-.503 3.322-.93 4.91-1.582C27.01 9.921 30.23 3.759 36.38 1.499c7.233-2.66 16.263-2.1 23.847-.689 7.27 1.352 13.76 4.91 19.918 8.394 3.867 2.19 10.493 4.789 10.266 10.347-.146 3.524-4.928 6.866-7.445 8.933-4.709 3.881-9.79 6.888-14.971 9.246-3.187 1.45-6.882 2.916-9.33 5.871-1.767 2.129-2.294 4.698-2.799 7.362-.344 1.83-.808 3.583-1.752 5.143-2.272 3.758-7.2 5.347-11.631 5.117-4.6-.24-8.93-2.121-13.025-4.22-7.603-3.89-14.858-8.69-20.24-15.126-2.63-3.141-4.891-6.771-5.392-10.846-.772-6.294 2.736-12.38 8.17-15.416z' stroke='%23050101' stroke-width='.878' stroke-linecap='round' mask='url(%23h)'/%3E%3C/g%3E%3Cg transform='translate(22 35)'%3E%3Cmask id='j' fill='%23fff'%3E%3Cuse xlink:href='%23i'/%3E%3C/mask%3E%3Cpath d='M6.061 13.59c1.53-.853 3.183-1.414 4.87-1.91 2.027-.601 4.098-1.104 6.04-1.917C24.531 6.6 28.138-1.564 35.733-4.56c9.033-3.594 20.35-2.956 29.814-1.356C74.624-4.386 82.724 0 90.697 4.114c4.957 2.562 13.79 5.573 13.668 12.483-.07 4.42-6.27 8.575-9.358 11.014A71.764 71.764 0 0 1 76.35 38.257c-4.039 1.578-8.861 3.083-12.022 6.523-2.334 2.537-2.997 5.66-3.677 8.846-.457 2.168-.988 4.304-2.107 6.24-2.686 4.653-8.591 6.742-13.991 6.49-5.484-.258-10.65-2.522-15.568-4.945-9.132-4.505-18.044-9.79-24.9-17.192C.738 40.604-2.19 36.35-2.972 31.481-4.12 24.367-.246 17.114 6.061 13.59z' stroke='%23050101' stroke-width='.805' stroke-linecap='round' mask='url(%23j)'/%3E%3C/g%3E%3Cg transform='translate(22 35)'%3E%3Cmask id='l' fill='%23fff'%3E%3Cuse xlink:href='%23k'/%3E%3C/mask%3E%3Cpath d='M5.913 9.325c2.41-.693 4.873-1.276 7.174-2.253C22.051 3.278 26.05-6.865 35.083-10.615c10.844-4.505 24.436-3.816 35.782-2.03 10.88 1.713 20.598 6.925 30.381 11.666 6.051 2.934 17.071 6.36 17.071 14.623 0 5.313-7.613 10.288-11.268 13.095a79.283 79.283 0 0 1-22.34 12.045c-4.899 1.695-10.84 3.244-14.719 7.172-4.87 4.939-3.812 11.94-7.017 17.67-3.099 5.547-9.98 8.141-16.347 7.865-6.37-.277-12.37-2.92-18.11-5.675-10.661-5.113-21.231-10.89-29.562-19.258-4.068-4.09-7.65-8.97-8.73-14.622-1.51-7.945 2.723-16.357 9.9-20.37 1.815-1.013 3.784-1.665 5.789-2.241z' stroke='%23050101' stroke-width='.732' stroke-linecap='round' mask='url(%23l)'/%3E%3C/g%3E%3Cg stroke='%23050101' stroke-linecap='round'%3E%3Cpath d='M113.17 97.707H27.053c-2.792 0-5.053-2.253-5.053-5.034V40.031c0-2.777 2.261-5.03 5.053-5.03h86.117c2.792 0 5.053 2.253 5.053 5.03v52.642c0 2.781-2.261 5.034-5.053 5.034z' stroke-width='2'/%3E%3Cpath d='M70.111 97.707C58.956 85.774 56.933 66.352 56.933 66.352s31.179-12.708 60.682-13.9' stroke-width='.525' stroke-dasharray='1.504'/%3E%3C/g%3E%3Ctext font-family='Rota-BlackItalic, Rota' font-size='6.54' font-style='italic' font-weight='800' fill='%23231916' transform='translate(22 35)'%3E%3Ctspan x='29.04' y='31.673'%3E100%3C/tspan%3E%3C/text%3E%3C/g%3E%3C/svg%3E"
            /></i>
            <strong class="d-b c-26">Terrain <br class="in-h5" />Digitalization</strong>
          </li>
          <li class="reveal">
            <i class="m-a d-b"
              ><img
                width="100%"
                height="100%"
                alt="Integrated Field Survey"
                src="data:image/svg+xml,%3Csvg width='140' height='140' viewBox='0 0 140 140' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Cdefs%3E%3Cpath id='a' d='M0 .854h72.73v2.42H0z'/%3E%3C/defs%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath d='M119.596 101.113V40.696c0-.921-.742-1.668-1.657-1.668h-13.663c-.915 0-1.657.747-1.657 1.668V100.7M113.459 48.196h4.83' stroke='%23000' stroke-width='2' stroke-linecap='round'/%3E%3Cpath stroke='%23000' stroke-width='2.05' stroke-linecap='round' d='M113.459 59.108h4.83'/%3E%3Cpath stroke='%23000' stroke-width='2' stroke-linecap='round' d='M113.459 70.02h4.83M113.459 80.932h4.83M113.459 93.105h4.83'/%3E%3Cpath d='M15 42.077h21.135c16.193 0 29.32 13.216 29.32 29.52 0 16.3 13.126 29.515 29.32 29.515h28.294' stroke='%23000' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath stroke='%23231916' stroke-width='.82' stroke-linecap='round' stroke-dasharray='1.94' d='M20.909 42.078h81.71M65.909 64.078L96.5 64'/%3E%3Cpath d='M15 49.455h22.742c12.323 0 22.316 10.057 22.316 22.468v2.208c0 18.038 14.52 32.658 32.436 32.658H125' stroke='%23000' stroke-width='.705' stroke-linecap='round' stroke-dasharray='1.94'/%3E%3Cpath d='M15 68.566h19.002c9.887 0 18.621 6.705 20.799 14.98.131 0 .258 1.469.39 1.469 2.968 12.026 15.783 21.774 30.279 21.774h27.105' stroke='%23000' stroke-width='.705' stroke-linecap='round' stroke-dasharray='1.94'/%3E%3Cpath d='M15 87.678h15.263c7.45 0 14.926 3.353 19.285 7.49.258 0 .517.734.78.734 5.937 6.016 17.037 10.887 28.117 10.887h21.705' stroke='%23000' stroke-width='.705' stroke-linecap='round' stroke-dasharray='1.94'/%3E%3Cg transform='translate(15 103.871)'%3E%3Cmask id='b' fill='%23fff'%3E%3Cuse xlink:href='%23a'/%3E%3C/mask%3E%3Cpath stroke='%23000' stroke-width='.705' stroke-linecap='round' stroke-dasharray='1.94' mask='url(%23b)' d='M0 2.919h72.729'/%3E%3C/g%3E%3Cpath stroke='%23000' stroke-width='.734' stroke-linecap='round' d='M96.601 43.29v56.612'/%3E%3Cpath fill='%23000' d='M93.606 45.734l.537.504 2.456-2.663 2.46 2.663.538-.504-2.998-3.245zM93.606 97.457l.537-.503 2.456 2.662 2.46-2.662.538.503-2.998 3.245z'/%3E%3Cpath stroke='%23000' stroke-width='.55' stroke-linecap='round' d='M115.341 87.042h3.403M115.341 75.486h3.403M115.341 64.388h3.403M115.341 53.505h3.403'/%3E%3C/g%3E%3C/svg%3E"
            /></i>
            <strong class="d-b c-26">Integrated <br class="in-h5" />Field Survey</strong>
          </li>
          <li class="reveal">
            <i class="m-a d-b"
              ><img
                width="100%"
                height="100%"
                alt="Online Support & OTA"
                src="data:image/svg+xml,%3Csvg width='140' height='140' viewBox='0 0 140 140' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Cdefs%3E%3Cpath id='a' d='M0 0h100v100H0z'/%3E%3C/defs%3E%3Cg transform='translate(20 20)' fill='none' fill-rule='evenodd'%3E%3Cmask id='b' fill='%23fff'%3E%3Cuse xlink:href='%23a'/%3E%3C/mask%3E%3Cg mask='url(%23b)'%3E%3Cpath d='M30.41 49.05c6 0 8.76-2.04 10.38-10.5.3-1.5.42-2.94.42-4.02 0-5.34-2.85-6.9-7.86-6.9-6.27 0-8.79 2.1-10.35 10.59-.27 1.44-.42 2.85-.42 3.96 0 5.31 2.61 6.87 7.83 6.87zm.12-3.15c-3.21 0-3.99-1.14-3.99-3.96 0-.96.12-2.25.39-3.66 1.02-5.34 2.04-7.53 6.24-7.53 3 0 4.11 1.23 4.11 4.05 0 .96-.18 2.28-.42 3.63-1.02 5.43-2.25 7.47-6.33 7.47zm19.68 2.85l3.39-17.52h5.67l.66-3.3H44.69l-.66 3.3h5.79l-3.39 17.52h3.78zm10.41 0l3.06-5.55h8.49l.78 5.55h3.99l-3.39-20.82h-5.16L56.45 48.75h4.17zm11.13-8.58h-6.39l4.83-8.79h.36l1.2 8.79z' fill='%23333' fill-rule='nonzero'/%3E%3C/g%3E%3Crect stroke='%23000' stroke-width='2' x='6.484' y='10' width='87.032' height='58' rx='11'/%3E%3Cpath stroke='%23000' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' d='M50.442 68.433v21.642h21.412-43.16'/%3E%3C/g%3E%3C/svg%3E"
            /></i>
            <strong class="d-b c-26">Online Support <br class="in-h5" />& OTA</strong>
          </li>
        </ul>
      </section>
      <!-- area-1:end -->
      <section class="area-2 pl-360 pr-360" id="overview">
        <h2 class="m-0 ta-c ff-asb">Make Farmland Leveling Precise</h2>
        <div class="desc">
          <p class="c-59">
            FJD AL01 3D Land Leveling System uses GNSS & RTK high-precision positioning technology to provide a
            comprehensive solution for farmland leveling. This GPS land leveling system can optimize water management,
            improve productivity, and increase yields.
          </p>
          <!-- <img
              class="folder"
              src="@/assets/images/al01-3d-land-leveling-system/flod-arrow.svg"
              alt="arrow"
            /> -->
        </div>
        <div class="video-box from-bottom">
          <video
            width="100%"
            height="100%"
            x5-playsinline
            x5-video-player-type="h5"
            x-webkit-airplay="allow"
            playsinline
            webkit-playsinline
            muted
            loop
            autoplay
            controls
            src="//1500006283.vod2.myqcloud.com/6c9ac49bvodcq1500006283/b3070c0b387702303614225476/uoadqNOAX1gA.mp4"
            poster="//1500006283.vod2.myqcloud.com/4384b243vodtranscq1500006283/723ca12d387702303535853325/sampleSnapshot/sampleSnapshot_10_0.jpg"
          ></video>
        </div>
      </section>
      <!-- area-2:end -->
      <Application
        :app-h2="'Application'"
        app-desc="Use FJD Land Leveling System to reclaim wasteland, consolidate and level fields, convert slopes into terraces, and optimize water usage for rice paddies."
        :application-data="applicationData"
      />
      <!-- <section class="area-3 pl-360 pr-360">
        <h2 class="m-0 ta-c ff-asb c-26">Application</h2>
        <div class="desc">
          <p class="c-59">
            Use FJD Land Leveling System to reclaim wasteland, consolidate and level fields, convert slopes into
            terraces, and optimize water usage for rice paddies.
          </p>
        </div>
        <div id="swiper_area3" class="p-r ov-h">
          <ul class="d-f jc-sb c-fff swiper-wrapper">
            <li class="p-r swiper-slide">
              <img
                src="@/assets/images/al01-3d-land-leveling-system/area_3_1.jpg"
                width="100%"
                height="100%"
                alt="Wasteland Reclamation"
              />
              <span class="p-a d-b"
                >Wasteland <br />
                Reclamation</span
              >
            </li>
            <li class="p-r swiper-slide">
              <img
                src="@/assets/images/al01-3d-land-leveling-system/area_3_2.jpg"
                width="100%"
                height="100%"
                alt="Land Consolidation And Leveling"
              />
              <span class="p-a d-b"
                >Land Consolidation <br />
                And Leveling</span
              >
            </li>
            <li class="p-r swiper-slide">
              <img
                src="@/assets/images/al01-3d-land-leveling-system/area_3_3.png"
                width="100%"
                height="100%"
                alt="Conversion Of Slopes Into Terraces"
              />
              <span class="p-a d-b"
                >Conversion of Slopes<br />
                Into Terraces</span
              >
            </li>
            <li class="p-r swiper-slide">
              <img
                src="@/assets/images/al01-3d-land-leveling-system/area_3_4.png"
                width="100%"
                height="100%"
                alt="Paddy Field Work"
              />
              <span class="p-a d-b">Paddy Field Work</span>
            </li>
          </ul>
          <div class="swiper-pagination in-h5"></div>
        </div>
      </section> -->
      <!-- area-3:end -->
      <section class="area-4" id="feature">
        <div class="area-4-sticky">
          <div class="pl-360 pr-360">
            <h2 class="m-0 ta-c ff-asb area-4-title c-26">Benefits</h2>
            <div class="area-4-content ov-h d-f">
              <ul class="area-4-number ov-h d-f fd-c jc-sb ai-fe">
                <li class="reveal">
                  <div class="d-f jc-sb ai-fs">
                    <i
                      ><img
                        width="100%"
                        height="100%"
                        src="data:image/svg+xml,%3Csvg width='17' height='30' viewBox='0 0 17 30' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Cdefs%3E%3Cpath d='M11.333 0v18.45H17L8.5 30 0 18.45h6.044V0h5.29z' id='a'/%3E%3C/defs%3E%3Cuse fill-opacity='.851' fill='%23000' xlink:href='%23a' fill-rule='evenodd'/%3E%3C/svg%3E"
                    /></i>
                    <strong class="ff-asb lh-12 c-26">22%</strong>
                  </div>
                  <div class="c-59 ta-r">Water Consumption</div>
                </li>
                <li class="reveal">
                  <div class="d-f jc-sb ai-fs">
                    <i
                      ><img
                        width="100%"
                        height="100%"
                        src="data:image/svg+xml,%3Csvg width='17' height='30' viewBox='0 0 17 30' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Cdefs%3E%3Cpath d='M11.333 0v18.45H17L8.5 30 0 18.45h6.044V0h5.29z' id='a'/%3E%3C/defs%3E%3Cuse fill-opacity='.851' fill='%23000' xlink:href='%23a' fill-rule='evenodd'/%3E%3C/svg%3E"
                    /></i>
                    <strong class="ff-asb lh-12 c-26">10%</strong>
                  </div>
                  <div class="c-59 ta-r">Fuel Consumption</div>
                </li>
                <li class="reveal">
                  <div class="d-f jc-sb ai-fs">
                    <i>
                      <img
                        width="100%"
                        height="100%"
                        src="data:image/svg+xml,%3Csvg width='17' height='30' viewBox='0 0 17 30' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Cdefs%3E%3Cpath d='M11.333 0v18.45H17L8.5 30 0 18.45h6.044V0h5.29z' id='a'/%3E%3C/defs%3E%3Cuse fill-opacity='.851' fill='%23000' xlink:href='%23a' transform='matrix(1 0 0 -1 0 30)' fill-rule='evenodd'/%3E%3C/svg%3E"
                    /></i>
                    <strong class="ff-asb lh-12 c-26">40%</strong>
                  </div>
                  <div class="c-59 ta-r">Work Efficiency</div>
                </li>
              </ul>
              <div class="area-4-video-box p-r ov-h">
                <video
                  width="100%"
                  height="100%"
                  x5-playsinline
                  x5-video-player-type="h5"
                  x-webkit-airplay="allow"
                  playsinline
                  webkit-playsinline
                  muted
                  loop
                  preload="none"
                  autoplay
                  src="//1500006283.vod2.myqcloud.com/6c9ac49bvodcq1500006283/00b400c2387702304133407126/IdnKckbJaP0A.mp4"
                  poster="//1500006283.vod2.myqcloud.com/4384b243vodtranscq1500006283/00b400c2387702304133407126/coverBySnapshot_10_0.jpg"
                ></video>
              </div>
            </div>
          </div>
          <!-- <i class="mask-img in-pc"><b></b></i> -->
        </div>
      </section>
      <section class="area-5 pl-60 pr-60">
        <h2 class="m-0 ta-c ff-asb c-26">Light-Load/Heavy-Load Mode Switch</h2>
        <div class="area-5-mod area-5-mod-1 d-f jc-sb">
          <i class="area-5-mod-img fs-0">
            <video
              width="100%"
              height="100%"
              x5-playsinline
              x5-video-player-type="h5"
              x-webkit-airplay="allow"
              playsinline
              webkit-playsinline
              autoplay
              muted
              loop
              preload="none"
              src="//1500006283.vod2.myqcloud.com/6c9ac49bvodcq1500006283/b9e531cc387702302448008582/svSZ2PoH7K8A.mp4"
              poster="//1500006283.vod2.myqcloud.com/4384b243vodtranscq1500006283/b9e531cc387702302448008582/sampleSnapshot/sampleSnapshot_10_0.jpg"
            ></video>
          </i>
          <div class="area-5-mod-text d-f fd-c jc-c">
            <h3 class="m-0 c-26 reveal">Precise Leveling</h3>
            <div class="desc reveal">
              <!-- <p>
                  For low horsepower(&lt;90HP), light load mode is suitable for
                  precise leveling. It works exceptionally well for fields with
                  small height differences. The light load mode can effectively
                  save 10% of the fuel to improve work efficiency with the same
                  configurations and surroundings. The highest speed can reach
                  15 km/h.
                  <div> Compared to the original way of leveling, AL01 can help save 22% of the water usage.</div>
                  <span
                    >Compared to the original way of leveling, AL01 can help
                    save 22% of the water usage.</span
                  >
                </p>-->
              <p class="c-59">
                The light-load mode is suitable for fine-leveling fields with small elevation differences. It consumes
                10% less fuel in comparison with the heavy-load mode under the same condition. The highest speed of
                light-load mode: 15km/h. Leveled farmland saves up to 22% on water usage in comparison with an unleveled
                counterpart.
              </p>
              <!-- <img
                  class="folder"
                  src="@/assets/images/al01-3d-land-leveling-system/flod-arrow.svg"
                  alt="arrow"
                /> -->
            </div>
          </div>
        </div>
        <div class="area-5-mod area-5-mod-2 d-f jc-sb fd-r">
          <i class="area-5-mod-img fs-0">
            <video
              width="100%"
              height="100%"
              x5-playsinline
              x5-video-player-type="h5"
              x-webkit-airplay="allow"
              playsinline
              webkit-playsinline
              autoplay
              muted
              loop
              preload="none"
              src="//1500006283.vod2.myqcloud.com/6c9ac49bvodcq1500006283/8e4922cf387702302549840525/gl9AAMS2OAwA.mp4"
              poster="//1500006283.vod2.myqcloud.com/4384b243vodtranscq1500006283/8e4922cf387702302549840525/sampleSnapshot/sampleSnapshot_10_0.jpg"
            ></video>
          </i>
          <div class="area-5-mod-text d-f fd-c jc-c ta-r">
            <h3 class="m-0 c-26 reveal">Wasteland Reclamation</h3>
            <div class="desc reveal">
              <p class="c-59">
                The heavy-load mode levels fields with large elevation differences and works wonder at the early stage
                of wasteland reclamation.
              </p>
              <!-- <img
                  class="folder"
                  src="@/assets/images/al01-3d-land-leveling-system/flod-arrow.svg"
                  alt="arrow"
                /> -->
            </div>
          </div>
        </div>
      </section>
      <!-- area-5:end -->
      <section class="area-6">
        <div class="pl-360 pr-360">
          <h2 class="m-0 ta-c ff-asb c-26">GNSS-based Land Leveling System</h2>
          <div class="area-6-content">
            <div class="desc">
              <p class="c-59">
                Say goodbye to the laser system's troubling setup, limited signal coverage, and demanding weather
                conditions. Say hello to AL01, the GNSS-based land leveling system that achieves 2.5cm accuracy
                <sup class="mark"
                  ><a class="mark" href="#footnote-1" aria-label="脚注 1" data-modal-close="" one-link-mark="yes"
                    >1</a
                  ></sup
                >
                , increases efficiency by 40%, and covers a larger area in comparison
                <sup class="mark"
                  ><a class="mark" href="#footnote-2" aria-label="脚注 2" data-modal-close="" one-link-mark="yes"
                    >2</a
                  ></sup
                >
                .
              </p>
              <!-- <img
                  class="folder"
                  src="@/assets/images/al01-3d-land-leveling-system/flod-arrow.svg"
                  alt="arrow"
                /> -->
            </div>
            <div class="video-wrap ov-h from-bottom">
              <video
                width="100%"
                height="100%"
                x5-playsinline
                x5-video-player-type="h5"
                x-webkit-airplay="allow"
                playsinline
                webkit-playsinline
                autoplay
                muted
                loop
                preload="none"
                src="//1500006283.vod2.myqcloud.com/6c9ac49bvodcq1500006283/ba1a6f12387702302448036866/b5awk38DWhEA.mp4"
                poster="//1500006283.vod2.myqcloud.com/4384b243vodtranscq1500006283/ba1a6f12387702302448036866/sampleSnapshot/sampleSnapshot_10_0.jpg"
              ></video>
            </div>
            <p class="ta-r c-8c tips">1. Accuracy varies in conditions.</p>
            <p class="ta-r c-8c tips">
              2. The comparison of efficiency and signal coverage takes place under the same environment and with the
              same machinery configuration.
            </p>
          </div>
        </div>
      </section>
      <!-- area-6:end -->
      <section class="area-7">
        <div class="pl-360 pr-360">
          <h2 class="m-0 ta-c ff-asb c-26">Terrain Digitalization</h2>
          <div class="desc ta-c c-59">Minimize land leveling costs with terrain digitalization.</div>
          <div class="d-f area-7-content">
            <div class="area-7-tab p-r">
              <ul class="area-7-tab-pagination p-r c-26">
                <li>
                  <!-- <strong>Real-time <br />Cut/Fill Map</strong>
                    <div>Real-time Cut/Fill map guides the operator to level the least amount of earth to create desired flat or slope by providing the best-fit surface.</div> -->
                </li>
              </ul>
              <i class="line" ref="area7Line"></i>
            </div>
            <div class="area-7-swiper ov-h p-r" id="area-7-swiper">
              <div class="swiper-wrapper">
                <client-only>
                  <swiper class="" :options="swiperOption" ref="bannerSwiper">
                    <swiper-slide v-for="(item, index) in bannerData" :key="index">
                      <i>
                        <video
                          v-if="item.isVideo"
                          width="100%"
                          height="100%"
                          x5-playsinline
                          x5-video-player-type="h5"
                          x-webkit-airplay="allow"
                          playsinline
                          webkit-playsinline
                          autoplay
                          muted
                          loop
                          preload="none"
                          :src="item.src"
                          :poster="item.img"
                        ></video>
                        <img
                          v-else
                          class="lazy-image"
                          :src="item.img"
                          data-original="@/assets/images/trion-s1-3d-lidar-scanner/TRION-METAHUB.png"
                          :alt="item.alt"
                          width="100%"
                          height="100%"
                        />
                      </i>
                    </swiper-slide>
                  </swiper>
                </client-only>

                <!-- <div class="swiper-slide">
                  <i>
                    <video
                      width="100%"
                      height="100%"
                      x5-playsinline
                      x5-video-player-type="h5"
                      x-webkit-airplay="allow"
                      playsinline
                      webkit-playsinline
                      autoplay
                      muted
                      loop
                      preload="none"
                      src="//1500006283.vod2.myqcloud.com/6c9ac49bvodcq1500006283/bc39528e387702302448106972/GprfFAJukyoA.mp4"
                      poster="//1500006283.vod2.myqcloud.com/4384b243vodtranscq1500006283/bc39528e387702302448106972/sampleSnapshot/sampleSnapshot_10_0.jpg"
                    ></video>
                  </i>
                </div>
                <div class="swiper-slide">
                  <i>
                    <img
                      src="@/assets/images/al01-3d-land-leveling-system/Speed.jpg"
                      width="100%"
                      height="100%"
                      alt="Speed Display"
                    />
                  </i>
                </div>
                <div class="swiper-slide">
                  <i>
                    <img
                      src="@/assets/images/al01-3d-land-leveling-system/Area-etering.jpg"
                      width="100%"
                      height="100%"
                      alt="Area Metering"
                    />
                  </i>
                </div> -->
              </div>
            </div>
          </div>
        </div>
      </section>
      <!-- area-7:end -->
      <section class="area-8">
        <div class="pl-360 pr-360">
          <h2 class="m-0 ta-c ff-asb c-26">Integrated Field Survey</h2>
          <div class="area-8-swiper ov-h p-r" id="area-8-swiper">
            <div class="swiper-wrapper">
              <client-only>
                <swiper class="" :options="area8SwiperOption" ref="area8Swiper">
                  <swiper-slide v-for="(item, index) in area8SwiperData" :key="index">
                    <i class="d-b img-box">
                      <video
                        width="100%"
                        height="100%"
                        x5-playsinline
                        x5-video-player-type="h5"
                        x-webkit-airplay="allow"
                        playsinline
                        webkit-playsinline
                        muted
                        loop
                        :src="item.src"
                        :data-src="item.src"
                        :poster="item.img"
                      ></video>
                    </i>
                    <div>
                      {{ item.desc }}
                    </div>
                  </swiper-slide>
                </swiper>
              </client-only>

              <!-- <div class="swiper-slide">
                <i class="d-b img-box">
                  <video
                    width="100%"
                    height="100%"
                    x5-playsinline
                    x5-video-player-type="h5"
                    x-webkit-airplay="allow"
                    playsinline
                    webkit-playsinline
                    muted
                    loop
                    preload="none"
                    data-src="//1500006283.vod2.myqcloud.com/6c9ac49bvodcq1500006283/b9e52c81387702302448008400/GnKjXu5gDJMA.mp4"
                    poster="//1500006283.vod2.myqcloud.com/4384b243vodtranscq1500006283/b9e52c81387702302448008400/sampleSnapshot/sampleSnapshot_10_0.jpg"
                  ></video>
                </i>
                <div>
                  Survey the field, determine the benchmark elevation, adjust the scraper, and level the farmland based
                  on the benchmark right in the cab.
                </div>
              </div>
              <div class="swiper-slide">
                <i class="d-b img-box">
                  <video
                    width="100%"
                    height="100%"
                    x5-playsinline
                    x5-video-player-type="h5"
                    x-webkit-airplay="allow"
                    playsinline
                    webkit-playsinline
                    muted
                    loop
                    preload="none"
                    data-src="//1500006283.vod2.myqcloud.com/6c9ac49bvodcq1500006283/ba1a6e6a387702302448036813/NKoXgpcNrfkA.mp4"
                    poster="//1500006283.vod2.myqcloud.com/4384b243vodtranscq1500006283/ba1a6e6a387702302448036813/sampleSnapshot/sampleSnapshot_10_0.jpg"
                  ></video>
                </i>
                <div>Mannually lower the scraper blade to the desired elevation and set it as the benchmark.</div>
              </div>
              <div class="swiper-slide">
                <i class="d-b img-box">
                  <video
                    width="100%"
                    height="100%"
                    x5-playsinline
                    x5-video-player-type="h5"
                    x-webkit-airplay="allow"
                    playsinline
                    webkit-playsinline
                    muted
                    loop
                    preload="none"
                    data-src="//1500006283.vod2.myqcloud.com/6c9ac49bvodcq1500006283/b9e52866387702302448008315/A1THIgDusa0A.mp4"
                    poster="//1500006283.vod2.myqcloud.com/4384b243vodtranscq1500006283/b9e52866387702302448008315/sampleSnapshot/sampleSnapshot_10_0.jpg"
                  ></video>
                </i>
                <div>
                  Two ways to set a benchmark for leveling an uneven slope. 1. Determine the elevations of the highest
                  and lowest points of a slope for the system to configure a flat surface as the benchmark. 2. Determine
                  the elevation of a point and manually increase or decrease the value to create a difference, which
                  enables the creation of a benchmark surface.
                </div>
              </div> -->
            </div>
            <div class="area-8-swiper-tab-wrap w-100p p-a z-3">
              <div class="area-8-swiper-tab d-f jc-sb"></div>
              <i class="line" ref="area8Line"></i>
            </div>
          </div>
        </div>
      </section>
      <!-- area-8:end -->
    </div>
  </div>
</template>

<script>
  import { gsap } from 'gsap'
  import { ScrollTrigger } from 'gsap/dist/ScrollTrigger.js'
  import bannerScroll from '@/mixins/bannerScroll.js'

  import bannerImg from '@/assets/images/al01-3d-land-leveling-system/banner.jpg'
  import bannerProductImg from '@/assets/images/al01-3d-land-leveling-system/banner-product.png'
  import ProductBanner from '@/components/ProductBanner'
  import Application from '@/components/Application'

  import SpeedImg from '@/assets/images/al01-3d-land-leveling-system/Speed.jpg'

  import AreaEteringImg from '@/assets/images/al01-3d-land-leveling-system/Area-etering.jpg'

  const area7TabItemText = ['Real-time <br />Cut/Fill Map', 'Speed Display', 'Area Metering']
  const area7TabItemDesc = [
    'Guides the operator to move the least amount of earth to create the desired surface.',
    "Tells the tractor's real-time speed.",
    'Counts leveled acres. '
  ]
  const area8TabItem = [
    'Benchmark <br class="in-h5"/>Auto-setting',
    'Benchmark <br class="in-h5"/>Manual-setting',
    'Slope <br class="in-h5"/>Benchmark Setting'
  ]

  export default {
    components: {
      ProductBanner,
      Application
    },
    mixins: [bannerScroll],
    data() {
      const vm = this
      return {
        bannerProductImg,
        bannerImg,
        bannerData: [
          {
            isVideo: true,
            src: '//1500006283.vod2.myqcloud.com/6c9ac49bvodcq1500006283/bc39528e387702302448106972/GprfFAJukyoA.mp4',
            img: '//1500006283.vod2.myqcloud.com/4384b243vodtranscq1500006283/bc39528e387702302448106972/sampleSnapshot/sampleSnapshot_10_0.jpg',
            alt: ''
          },
          {
            isVideo: false,
            img: SpeedImg,
            alt: 'Speed Display'
          },
          {
            isVideo: false,
            img: AreaEteringImg,
            alt: 'Area Metering'
          }
        ],
        applicationData: [
          {
            imgUrl: require('@/assets/images/al01-3d-land-leveling-system/area_3_1.jpg'),
            imgDesc: 'Wasteland<br>Reclamation'
          },
          {
            imgUrl: require('@/assets/images/al01-3d-land-leveling-system/area_3_2.jpg'),
            imgDesc: 'Land Consolidation<br>And Leveling'
          },
          {
            imgUrl: require('@/assets/images/al01-3d-land-leveling-system/area_3_3.jpg'),
            imgDesc: 'Conversion of Slopes<br>Into Terraces'
          },
          {
            imgUrl: require('@/assets/images/al01-3d-land-leveling-system/area_3_4.jpg'),
            imgDesc: 'Paddy Field <br>Work'
          }
        ],
        swiperOption: {
          loop: true,
          slidesPerView: 1,
          spaceBetween: 2,
          effect: 'fade',
          autoplay: {
            delay: 3000
          },
          pagination: {
            el: '.area-7-tab-pagination',
            clickable: true,
            renderBullet(index, className) {
              return (
                '<li class="' +
                className +
                '"><strong>' +
                area7TabItemText[index] +
                "</strong><div class='c-26'>" +
                area7TabItemDesc[index] +
                '</div></li>'
              )
            }
          },
          on: {
            init() {
              vm.$refs.area7Line.style.height = '2.9rem'
            },
            slideChange() {
              const index = this.realIndex
              const paginations = document.querySelectorAll('.area-7-tab-pagination li')
              const curActive = paginations[index]
              vm.$refs.area7Line.style.height = `${curActive.scrollHeight}px`
              vm.$refs.area7Line.style.transform = `translateY(${curActive.offsetTop}px)`
            }
          }
        },
        area8SwiperData: [
          {
            src: '//1500006283.vod2.myqcloud.com/6c9ac49bvodcq1500006283/b9e52c81387702302448008400/GnKjXu5gDJMA.mp4',
            img: '//1500006283.vod2.myqcloud.com/4384b243vodtranscq1500006283/b9e52c81387702302448008400/sampleSnapshot/sampleSnapshot_10_0.jpg',
            desc: 'Survey the field, determine the benchmark elevation, adjustthe scraper, and level the farmland based on the benchmark right in the cab.'
          },
          {
            src: '//1500006283.vod2.myqcloud.com/6c9ac49bvodcq1500006283/ba1a6e6a387702302448036813/NKoXgpcNrfkA.mp4',
            img: '//1500006283.vod2.myqcloud.com/4384b243vodtranscq1500006283/ba1a6e6a387702302448036813/sampleSnapshot/sampleSnapshot_10_0.jpg',
            desc: 'Mannually lower the scraper blade to the desired elevation and set it as the benchmark.'
          },
          {
            src: '//1500006283.vod2.myqcloud.com/6c9ac49bvodcq1500006283/b9e52866387702302448008315/A1THIgDusa0A.mp4',
            img: '//1500006283.vod2.myqcloud.com/4384b243vodtranscq1500006283/b9e52866387702302448008315/sampleSnapshot/sampleSnapshot_10_0.jpg',
            desc: 'Two ways to set a benchmark for leveling an uneven slope. 1. Determine the elevations of the highest and lowest points of a slope for the system to configure a flat surface as the benchmark. 2. Determine the elevation of a point and manually increase or decrease the value to create a difference, which enables the creation of a benchmark surface.'
          }
        ],
        videos: [],
        area8SwiperOption: {
          // loop: true,
          slidesPerView: 1,
          spaceBetween: 0,
          effect: 'slide',
          pagination: {
            el: '.area-8-swiper-tab',
            clickable: true,
            renderBullet(index, className) {
              return '<span class="' + className + '">' + area8TabItem[index] + '</span>'
            }
          },
          on: {
            init() {
              vm.videos = document.querySelectorAll('.area-8-swiper video')
              console.log('[ audio.play() ] >', vm.videos[0].play())
              const playPromise = vm.videos[0].play()
              if (playPromise !== undefined) {
                playPromise
                  .then(() => {
                    vm.videos[0].play()
                  })
                  .catch((e) => {
                    console.log('[ e ] >', e)
                  })
              }
              // if (vm.videos[0].load()) {
              //   vm.videos[0].play()
              // }
              // console.log('[ vm.videos[].src ] >', vm.videos[0])
            },
            slideChange() {
              const index = this.realIndex
              // vm.$refs.area7Line.style.transform = `translateY(${curActive.offsetTop}px)`

              vm.$refs.area8Line.style.transform = `translateX(${index * 100}%)`
              // vm.$refs.area8Line.style.left = '200px'
              console.log('[ vm.$refs.area8Line.style.transform ] >', vm.$refs.area8Line.style)
              const curPlayVideo = vm.videos[index]
              curPlayVideo.play()
              // console.log('[ videos ] >', videos, index)
              // const src = curPlayVideo['src']
              // const src = videos.eq(index).attr('src')
              // const realSrc = curPlayVideo['dataset']['src']
              // // console.log('[ src,realSrc ] >', curPlayVideo)
              // // if (!src) {
              // curPlayVideo.src = realSrc
              // // console.log('[ curPlayVideo.load() ] >', curPlayVideo.load())
              // const playPromise = curPlayVideo.play()
              // console.log('[ playPromise ] >', playPromise)
              // if (playPromise !== undefined) {
              //   playPromise
              //     .then(() => {
              //       console.log('[ curPlayVideo ] >', curPlayVideo)
              //       curPlayVideo.play()
              //     })
              //     .catch((e) => {
              //       console.log('[ e ] >', e)
              //     })
              // }

              // curPlayVideo.load() && curPlayVideo.play()
              // }
              // console.log('[ src,realSrc after ] >', { src, realSrc })
              // vm.videos.forEach((item) => {
              //   // if (idx === index) {
              //   //   item.play()
              //   // } else {
              //   //   item.pause()
              //   // }
              //   item.pause()
              // })

              // const realSrc = videos.eq(index).data('dataset')
              // const currItem = $('.area-8-swiper-tab span').eq(index)
              // if (!src) {
              //   videos.eq(index).attr('src', realSrc)
              // }
              // videos.each(function (i, n) {
              //   n.pause()
              // })
              // videos[index].play()
              // if (!isMobile()) {
              //   line.css('transform', 'translateX(' + index * 100 + '%)')
              // }
            }
          }
        }
      }
    },
    head() {
      return {
        script: [
          {
            type: 'application/ld+json',
            json: {
              '@context': 'https://schema.org/',
              '@type': 'ItemPage',
              '@graph': [
                {
                  '@type': 'Product',
                  name: '3D Excavator Guidance System',
                  url: 'https://www.fjdynamics.com/product/excavatorguidance.html',
                  image: 'https://www.fjdynamics.com/images/nav0526/nav_wjj.png',
                  description:
                    'FJD 3D excavator guidance system is an excavator 3d grade control system with high construction accuracy.',
                  brand: {
                    '@type': 'Brand',
                    name: 'FJDynamics'
                  },
                  review: [
                    {
                      '@type': 'Review',
                      reviewBody: 'High accuracy and easy to use, fit my Komatsu 700LC excavator perfect',
                      reviewRating: {
                        '@type': 'Rating',
                        ratingValue: '5',
                        bestRating: '5'
                      },
                      author: {
                        '@type': 'Person',
                        name: 'Komatsu 700LC excavator owner'
                      }
                    }
                  ]
                },
                {
                  '@type': 'BreadcrumbList',
                  itemListElement: [
                    {
                      '@type': 'ListItem',
                      position: 1,
                      name: 'Home',
                      item: 'https://www.fjdynamics.com'
                    },
                    {
                      '@type': 'ListItem',
                      position: 2,
                      name: 'Product',
                      item: 'https://www.fjdynamics.com/product.html'
                    },
                    {
                      '@type': 'ListItem',
                      position: 3,
                      name: '3D Excavator Grade Control Guidance System'
                    }
                  ]
                }
              ]
            }
          }
        ],
        title: '3D EXCAVATOR GUIDANCE SYSTEM',
        meta: [
          {
            hid: 'keywords',
            name: 'keywords',
            content: 'auto steer for tractor, auto steer, tractor gps'
          },
          // hid is used as unique identifier. Do not use `vmid` for it as it will not work
          {
            hid: 'description',
            name: 'description',
            content:
              'FJDynamics 3D excavator GPS grade control system reduces staking process. Using RTK combined with GNSS, positioning accuracy reaches 3cm.'
          }
        ]
      }
    },
    mounted() {
      // eslint-disable-next-line nuxt/no-env-in-hooks
      if (process.browser) {
        gsap.registerPlugin(ScrollTrigger)
        this.apllicationAnimate()
      }
    },
    methods: {
      apllicationAnimate() {
        gsap.from('.area-3 li', {
          scrollTrigger: {
            trigger: '.area-3',
            // scrub: true,
            // pin: true,
            start: '60% bottom',
            end: '60% bottom'
            // markers: true,
          },
          stagger: 0.3,
          duration: 1,
          y: '100%',
          opacity: 0
        })
      }
    }
  }
</script>

<style scoped lang="scss">
  @media screen and (min-width: 768px) {
    .fs-40 {
      font-size: 0.4rem;
    }
    .fs-20 {
      font-size: 0.2rem;
    }
    .fs-18 {
      font-size: 0.18rem;
    }
    .fs-16 {
      font-size: 0.16rem;
    }

    .pl-360 {
      padding-left: 3.6rem;
    }
    .pr-360 {
      padding-right: 3.6rem;
    }
    .w-12r {
      width: 12rem;
    }
    .w-10r {
      width: 10rem;
    }
    .content h2 {
      font-size: 0.48rem;
    }
    .main {
      margin-top: 3.958vw;
    }
    /* banner */
    .banner {
      // height: 8rem;
      // // top: 3.958vw;
      // width: 100%;
      // background-image: url('@/assets/images/al01-3d-land-leveling-system/banner.jpg');
    }
    .banner .crumb {
      padding-top: 0.34rem;
      font-size: 0.16rem;
    }
    .banner .crumb a:hover {
      color: #fff;
    }
    .banner-content {
      left: 2.14rem;
      top: 1.8rem;
    }
    .banner-title {
      margin-bottom: 0.08rem;
      font-size: 0.64rem;
      font-weight: 700;
    }
    .banner-title span {
      font-weight: 400;
    }
    .banner-desc {
      font-size: 0.36rem;
    }
    .banner-btn {
      margin-top: 0.32rem;
      font-size: 0.24rem;
      width: 1.7rem;
      line-height: 0.48rem;
      background: rgba(255, 255, 255, 0.65);
      transition: background-color 0.3s linear;
    }
    .banner-btn:hover {
      background: rgba(255, 255, 255, 0.75);
    }

    .content {
      margin-top: calc(8rem + 3.958vw);
    }
    .area-2 .folder,
    .area-3 .folder,
    .area-4 .folder,
    .area-5 .folder,
    .area-6 .folder {
      display: none;
    }

    /* nav-anchor */
    .nav-anchor {
      height: 0.56rem;
      top: 0.75rem;
      position: sticky;
      box-shadow: 0px 0.02rem 0.04rem 0px rgba(0, 0, 0, 0.1);
    }
    .nav-anchor > div {
      padding-left: 1.6rem;
      padding-right: 1.6rem;
    }
    .nav-anchor a {
      margin-left: 0.8rem;
    }
    .nav-anchor .nav-anchor-item a:hover {
      font-weight: 700;
    }
    .nav-anchor .dealer-free-quote-btn {
      width: 1.2rem;
      line-height: 0.32rem;
      transition: background-color 0.3s linear;
    }
    .nav-anchor .dealer-free-quote-btn:hover {
      color: #fff;
      background-color: rgba(34, 34, 34, 0.85);
    }
    /* area-1 */
    .area-1 ul {
      padding-bottom: 1.14rem;
    }
    .area-1 li {
      width: 3.84rem;
      margin-top: 0.88rem;
    }
    .area-1 li i {
      width: 1.4rem;
      height: 1.4rem;
      margin-bottom: 0.16rem;
    }
    .area-1 li strong {
      font-size: 0.2rem;
      font-weight: 400;
    }
    /* area-2 */
    .area-2 {
      margin-top: 1.6rem;
    }
    .area-2 .desc,
    .area-3 .desc {
      padding: 0.32rem 0;
    }
    /* area-3 */
    .area-3 {
      margin-top: 2rem;
      // margin-bottom: 2rem;
    }
    .area-3 li {
      width: 3rem;
      height: 4.78rem;
    }
    .area-3 li span {
      left: 0.3rem;
      bottom: 0.38rem;
    }
    /* area-4 */
    /* .area-4{height:560vh;} */
    /* .area-4-sticky{height:calc(100vh - 0.56rem); position: sticky;top:0.56rem; background-color: rgba(0,0,0,1);}   */
    /* .area-4-sticky>div{position: absolute; top:50%; left:50%; transform: translate(-50%, -50%);} */
    .area-4 {
      padding-top: 2rem;
    }
    .area-4 .area-4-title {
      position: relative;
      z-index: 8;
      color: #000;
    } /*color: rgba(255,255,255,1);*/
    .area-4-content {
      padding-top: 0.32rem;
    }
    .area-4-number {
      flex: 0 0 auto;
      width: 1.87rem;
      text-align: right;
    }
    .area-4-number li {
      width: 100%;
      text-align: center;
      padding-right: 0.24rem;
      padding-left: 0.08rem;
      padding-bottom: 0.08rem;
      border-bottom: 1px solid rgba(0, 0, 0, 0.35);
      // display: flex;
      // justify-content: space-between;
    }
    .area-4-number li strong {
      font-size: 0.64rem;
      display: inline-block;
      margin-bottom: 0.05rem;
      color: rgba(0, 0, 0, 0.85);
    }
    .area-4-number li div {
      font-size: 0.16rem;
      color: rgba(0, 0, 0, 0.65);
      white-space: nowrap;
    }
    .area-4-number li i {
      display: block;
      width: 0.17rem;
      height: 0.3rem;
      margin-top: 0.25rem;
    }
    .area-4-number li i img {
      display: block;
      width: 0.17rem;
      height: 0.3rem;
    }
    .area-4-video-box {
      flex: 0 0 auto;
      width: 9.96rem;
      height: 5.6rem;
      margin-left: 0.18rem;
    }
    /* .mask-img{display:block; position: absolute; z-index: 3; top:0; left:0; width:100%;height:100%; transform-origin: 50% 50%;  background:#000}   */
    /* .mask-img b{display:block;width:100%;height:100%;opacity: 0.2; background: url("//1500006283.vod2.myqcloud.com/4384b243vodtranscq1500006283/723ca12d387702303535853325/sampleSnapshot/sampleSnapshot_10_0.jpg") no-repeat center / cover;} */

    /* area-5 */
    .area-5 {
      margin-bottom: 2rem;
      margin-top: 2rem;
    }
    .area-5 h2 {
      margin-bottom: 0.48rem;
    }
    .area-5 .desc span {
      display: block;
    }
    .area-5-mod-img {
      display: block;
      position: relative;
      overflow: hidden;
      width: 50%;
      height: 5.05rem;
      background-color: #ccc;
    }
    .area-5-mod-text {
      width: 50%;
    }
    .area-5-mod-text h3,
    .area-5-mod-text div {
      margin-left: 0.65rem;
      margin-right: 0.65rem;
    }
    .area-5-mod-text h3 {
      font-size: 0.4rem;
      margin-bottom: 0.24rem;
    }
    .area-5-mod-text div {
      margin-bottom: 0.24rem;
    }
    .area-5-mod {
      background: #fafafa;
    }
    /* area-6 */
    .area-6 .desc {
      margin: 0.32rem 0;
    }
    .area-6 .video-wrap {
      height: 6.75rem;
      margin-bottom: 0.2rem;
    }
    .tips {
      font-size: 0.16rem;
      color: #8c8c8c;
      line-height: 0.24rem;
    }
    .mark:hover {
      color: #3081f2;
      cursor: pointer;
    }

    /* area-7 */
    .area-7 {
      margin-top: 2.14rem;
    }
    .area-7 .desc {
      margin: 0.16rem 0 0.32rem;
    }
    :deep(.area-7-swiper) {
      width: 9.45rem;
      height: 5.31rem;
    }
    :deep(.area-7-swiper i) {
      display: block;
      width: 100%;
      height: 100%;
      background-color: #ccc;
    }
    :deep(.area-7-tab) {
      width: 2.54rem;
      margin-top: 0.17rem;
    }
    :deep(.area-7-tab ul) {
      border-left: 1px solid #e6e6e6;
    }
    :deep(.area-7-tab li:nth-of-type(1)) {
      margin-top: 0;
    }
    :deep(.area-7-tab li > div) {
      display: none;
      margin-top: 0.18rem;
      color: rgba(0, 0, 0, 0.85);
      transition: all 0.3s linear;
    }
    :deep(.area-7-tab li strong) {
      cursor: pointer;
      color: rgba(0, 0, 0, 0.65);
      font-size: 0.2rem;
    }
    :deep(.area-7-tab li strong:hover) {
      color: #000;
    }
    :deep(.area-7-tab .line) {
      display: block;
      z-index: 2;
      position: absolute;
      left: 0;
      top: 0;
      transition: transform 0.3s linear;
      width: 2px;
      background-color: #333;
    }
    :deep(.area-7-tab .swiper-pagination-bullet) {
      width: auto;
      height: auto;
      position: relative;
      margin: 0.64rem 0.13rem 0;
      outline: none;
      background-color: transparent;
      border-radius: 0;
      opacity: 1;
      padding: 0;
    }
    :deep(.area-7-tab .swiper-pagination-bullet-active strong) {
      color: #333;
      font-size: 0.28rem;
      font-family: 'Alibaba Sans Bold';
      font-weight: 500;
    }
    :deep(.area-7-tab .swiper-pagination-bullet-active div) {
      display: block;
    }

    /* area-8 */
    .area-8 {
      padding: 2rem 0;
    }
    .area-8 h2 {
      margin-bottom: 0.32rem;
    }
    :deep(.area-8-swiper .img-box) {
      height: 6.75rem;
      margin-bottom: 1.12rem;
      background-color: #fff;
    }
    :deep(.area-8-swiper .swiper-slide div) {
      display: none;
    }
    :deep(.area-8-swiper .swiper-slide-active div) {
      display: block;
      color: #333;
      outline: none;
    }
    :deep(.area-8-swiper-tab-wrap) {
      top: 6.75rem;
      left: 0;
      padding-top: 0.16rem;
      border-bottom: 1px solid #979797;
      text-align: center;
    }
    :deep(.area-8-swiper-tab-wrap span) {
      display: inline-block;
      width: 33.333%;
      // padding: 0.16rem 0;
      cursor: pointer;
      font-size: 0.2rem;
      color: #666;
    }
    :deep(.area-8-swiper-tab-wrap .line) {
      display: inline-block;
      content: '';
      will-change: transform;
      transition: transform 0.3s linear;
      position: absolute;
      left: 0;
      bottom: -1px;
      width: 33.333%;
      height: 2px;
      background-color: #333;
    }
    :deep(.area-8-swiper .swiper-pagination-bullets .swiper-pagination-bullet) {
      margin: 0.16rem 0;
      height: 0.3rem;
      border-radius: 0;
      background-color: transparent;
      opacity: 1;
    }
    :deep(.area-8-swiper .swiper-pagination-bullets .swiper-pagination-bullet-active) {
      font-weight: 500;
      color: #333;
    }
    /* area-9 */
    .area-9 {
      padding-top: 1rem;
      padding-bottom: 2rem;
    }
    .area-9 h2 {
      margin-bottom: 0.48rem;
    }
    .componets-item {
      border-radius: 4px;
      margin-bottom: 0.16rem;
      transition: all 0.3s linear;
      padding: 0.16rem 0 0.16rem 0.16rem;
    }
    .componets-item:hover {
      transform: scale(1.01);
      box-shadow: 2px 2px 12px 0px rgba(0, 0, 0, 0.09);
    }
    .componets-item .img-box {
      width: 3.84rem;
      height: 2.16rem;
      flex: 0 0 auto;
    }
    .componets-item img {
      width: 3.84rem;
      height: 2.16rem;
      flex: 0 0 auto;
    }
    .componets-item .text-box {
      margin-left: 0.32rem;
      margin-right: 0.32rem;
      width: calc(8rem - 0.64rem);
      color: rgba(0, 0, 0, 0.85);
    }
    .componets-item .text-box strong {
      font-size: 0.32rem;
      margin-top: 0.48rem;
      margin-bottom: 0.16rem;
      color: #333;
    }
    .componets-item .desc {
      margin-bottom: 0.16rem;
    }
    .componets-item .tri-icon {
      width: 0.24rem;
      height: 0.24rem;
      margin-left: 0.15rem;
      transition: all 0.2s linear;
      background-image: url("data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill-rule='nonzero' fill='none'%3E%3Cpath fill-opacity='.01' fill='%23FFF' d='M0 0h24v24H0z'/%3E%3Cpath stroke='%23191923' stroke-width='1.273' fill='%23191923' stroke-linecap='round' stroke-linejoin='round' d='M5 9l7 7 7-7z'/%3E%3C/g%3E%3C/svg%3E");
    }
    .componets-item td {
      border: 1px solid #333;
      font-size: 0.14rem;
      padding-left: 0.32rem;
      padding-top: 0.03rem;
      padding-bottom: 0.03rem;
    }
    .componets-item .hide-text {
      display: none;
      margin-bottom: 0.3rem;
    }
  }
  // banner
  :deep(.banner-product-img) {
    width: 5.54rem;
    height: 2.8rem;
    top: 5.2rem;
    right: 1.96rem;
  }
</style>
